// src/components/Logout.js

import React from 'react';

const Logout = () => {
  return (
    <div>
      <h1>Logout</h1>
      <p>You have been logged out. Thank you for using our service.</p>
    </div>
  );
};

export default Logout;
